import type { FontByteSource } from '@dg-embalajes/font-library';

const emittedUrls = import.meta.glob('../generated-font-assets/*.woff', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Readonly<Record<string, string>>;

const urlsByFile = new Map(
  Object.entries(emittedUrls).map(([assetPath, url]) => [assetPath.split('/').at(-1), url]),
);

export const editorFontByteSource: FontByteSource = {
  async load(profile) {
    const url = urlsByFile.get(profile.assetFile);
    if (!url) throw new Error(`Vite no emitio la fuente controlada ${profile.assetFile}.`);
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP ${response.status} al cargar ${profile.assetFile}.`);
    }
    return new Uint8Array(await response.arrayBuffer());
  },
};
